import { Box, useTheme } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import { ClickableBox } from 'components/facets'
import { useTranslation } from 'react-i18next'

export interface OptionBoxProps {
  onClick: () => void
  title: string
  width?: string
  description?: string
  Icon?: string
  recommended?: boolean
  iconSize?: string
  dataTestid?: string
  disabled?: boolean
  selected?: boolean
}

export const OptionBox = ({
  onClick,
  title,
  Icon,
  description,
  width = '300px',
  iconSize = '5rem',
  recommended = false,
  dataTestid,
  disabled,
  selected,
}: OptionBoxProps): JSX.Element => {
  const { palette } = useTheme()
  const { t } = useTranslation()
  const padding = 24

  return (
    <ClickableBox onClick={disabled ? undefined : onClick} margin={2}>
      <Box
        style={{
          padding: `${padding}px`,
          color: disabled ? palette.disabled : 'inherit',
          border: '1px solid var(--card-border)',
          boxShadow: 'var(--box-shadow)',
          borderRadius: '8px',
        }}
        // paddingBottom={5}
        textAlign="center"
        width={width}
        position="relative"
        margin="0 auto"
        data-testid={dataTestid}
      >
        <h5 className="primary-color fw-semibold">{title}</h5>
        {Icon && (
          <i
            style={{ color: palette.primary.light, fontSize: iconSize, margin: '1rem 0rem' }}
            className={Icon}
          />
        )}
        <p>{description}</p>
        {recommended && (
          <Box width={width} textAlign="center" position="absolute" bottom="5px" right={`0px`}>
            <span className="primary-color">{t('common.recommended')}</span>
          </Box>
        )}
        {selected && <CheckCircle style={{ position: 'absolute', right: 10, bottom: 8 }} />}
      </Box>
    </ClickableBox>
  )
}
